import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SharedModule } from '@app/shared/shared.module'
import { UploadModalComponent } from './upload-modal.component'
import { MatDialogModule } from '@angular/material/dialog'
import { PipesModule } from '@app/shared/pipe/index.module'
import { ScopeUiAutocompleteComponent } from '../ui-components/scope-ui-autocomplete/scope-ui-autocomplete.component'
import { UploadModalHeaderComponent } from './upload-modal-header/upload-modal-header.component'
import { UploadModalValidationComponent } from './upload-modal-validation/upload-modal-validation.component'
import { UploadModalService } from './services/upload-modal.service'

const components = [UploadModalComponent, UploadModalValidationComponent, UploadModalHeaderComponent]

@NgModule({
  imports: [CommonModule, SharedModule, PipesModule, MatDialogModule, ScopeUiAutocompleteComponent],
  declarations: components,
  exports: components,
  providers: [UploadModalService],
})
export class UploadModalModule {}
